// src/components/Footer.js
import React from 'react';
import './Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-container">
        <p>&copy; 2025 E2e tech A.I. All rights reserved.</p>
        <p className="footer-subtitle">A love letter to mathematics, computing and solutions.</p>
      </div>
    </footer>
  );
}

export default Footer;